// extracted by mini-css-extract-plugin
export default {"Clock":"Clock_Clock__cfBtg"};